import React from 'react';
import Expenses from '../components/Expenses';

function ExpensesPage() {
  return (
    <Expenses/>
  );
}

export default ExpensesPage;
